import React, { useState } from 'react';
import "./contact-us-form.scss";
import axios from "axios";
import {CONTACT_US_API_PATH, SERVER_URL} from "../../../global_vars";
import DOMPurify from "dompurify";

interface ContactUsFormProps {
    setContactUsModal: (subscribeModal: boolean) => void;
}

function ContactUsForm(props: ContactUsFormProps) {
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [phone, setPhone] = useState<string>("");
    const [message, setMessage] = useState<string>("");
    const [consent, setConsent] = useState<boolean>(false);

    const socialImages = [
        {
            id: 1,
            name: "Facebook",
            defaultImageURL: "/Samples/facebook-white.png",
        },
        {
            id: 2,
            name: "Instagram",
            defaultImageURL: "/Samples/instagram-icon.png",
        },
        {
            id: 3,
            name: "Youtube",
            defaultImageURL: "/Samples/youtube-white.png",
        },
        {
            id: 4,
            name: "Tik Tok",
            defaultImageURL: "/Samples/tik-tok-white.png",
        }
    ]

    const submitForm = () => {
        // show error
        if (!consent) {
            return;
        }

        axios.post(`${SERVER_URL}${CONTACT_US_API_PATH}`, {
            full_name: firstName + " " + lastName,
            email: email,
            message: message,
            phone_number: phone,
            consent: consent,
        }).then((res) => {
            // show success
            console.log(res);
        }).catch((err) => {
            // show error
            console.log(err);
        });
    }

    return (
        <div className={"contact-us"}>
            <div className={"contact-us-form"}>
                <div>
                    <h2>GET IN TOUCH</h2>
                    
                </div>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "1em",
                }}>
                    <input type={"text"} className={"form-info"} value={firstName} placeholder={"First Name"} onChange={(e) => {
                        setFirstName(DOMPurify.sanitize(e.target.value));
                    }} required/>
                    <input type={"text"} className={"form-info"} value={lastName} placeholder={"Last Name"} onChange={(e) => {
                        setLastName(DOMPurify.sanitize(e.target.value));
                    }}required/>
                </div>

                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "1em",
                }}>
                    <input type={"email"} value={email} onChange={(e) => {
                        setEmail(DOMPurify.sanitize(e.target.value));
                    }} className={"form-info"} placeholder={"Email"} required/>
                    <input type={"tel"} className={"form-info"} value={phone} onChange={(e) => {
                        setPhone(DOMPurify.sanitize(e.target.value));
                    }} placeholder={"Phone"} required/>
                </div>

                <textarea name={"message"} rows={5} cols={50} value={message} onChange={(e) => {
                    setMessage(DOMPurify.sanitize(e.target.value));
                }} placeholder={"Message"} wrap={"soft"} maxLength={1000} required/>


                <div className={"contact-us-form-checkbox"}>
                <input type={"checkbox"} checked={consent} onChange={(e) => {
                    setConsent(e.target.checked);
                }} required />
                    <span>
                        By providing Luxora Dubai* your contact information, you acknowledge and agree to our Privacy Policy and consent to receiving marketing communications, including through automated calls, texts, and emails, some of which may use artificial or prerecorded voices. 
                        This consent isn’t necessary for purchasing any products or services and you may opt out at any time. To opt out from texts, you can reply, ‘stop’ at any time. To opt out from emails, you can click on the unsubscribe link in the emails. Message and data rates may apply.
                    </span>
                </div>
                <button className={"contact-us-form-btn"} onClick={(e) => {
                    e.preventDefault();
                    submitForm();
                }}>SUBMIT</button>

            </div>

            <div className={"contact-us-info"}>
                <img src={"/Samples/developer2.jpg"} alt={"contact us"} className={"contact-us-img"} />

                <div className={"contact-us-image-overlay"}></div>
                {/* <div style={{display: "flex", flexDirection:"row", justifyContent:"flex-end", width: "100%"}}> */}
                <button className={"close-btn"} onClick={() => {
                        props.setContactUsModal(false);
                }}><i className="bi bi-x-lg"></i></button>
                {/* </div> */}

                <div className={"contact-us-info-details"}>
                    {/* <div style={{display: "flex", flexDirection:"row", justifyContent:"flex-end", width: "100%"}}>
                        <button className={"close-btn"} onClick={() => {
                                props.setContactUsModal(false);
                        }}><i className="bi bi-x-lg"></i></button>
                    </div> */}
                    <h2 className={"company-name"}>LUXORA DUBAI</h2>
                    <div className={"contact-details"}>
                        <p>enquiries@luxoradubai.com</p>
                        <p>732.983.7089</p>
                    </div>

                    <div className={"contact-address"}>
                        <p>Metropolis Tower, Office Number 215</p>
                        <p>Business Bay, Dubai, United Arab Emirates</p>
                    </div>

                    {/* <div className={"social"}>
                    {
                        socialImages.map((image) => (
                            <a href={"/luxora-dubai"}><img src={image.defaultImageURL} 
                                alt={image.name}
                            /></a>
                        ))
                    }
                    </div> */}

                </div>

                
                

            </div>


        </div>
    )
}

export default ContactUsForm;